import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const storiesDetailsApi = createAsyncThunk(
    'auth/stories/details',
    async (id, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(apiRoutes.impactStoryAction(`story-details/${id}`, 0),
            )
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)
const intialState = { result: [], loading: false, error: null, message: "" }
const storiesDetailsSlice = createSlice({
    name: 'stories details',
    initialState: { result: [], loading: false, error: null, message: "" },
    reducers: {
        resetstories: () => intialState,
    },
    extraReducers: (builder) => {
        builder.addCase(storiesDetailsApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(storiesDetailsApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(storiesDetailsApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})
export const { resetstories } = storiesDetailsSlice.actions;
export const storiesDetailsReducer = storiesDetailsSlice.reducer